<div class="w-full bg-white border-box" style="border-radius: 10px;" id="election-union">
  <div class="p-30 bg-light-gray" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Organisations syndicales</p>
        <p class="no-margin dark-gray text-sm">Représentants syndicaux participant à la négociation</p>
      </div>
    </div>
  </div>

  <div class="p-30 flex flex-column gap-30">
    <div *ngFor="let union of unions; let i = index" class="p-10 bg-light-gray" style="border: solid 1px #F0F5FF;">
      <app-union [(union)]="unions[i]" [index]="i" (unionChange)="onUnionChange()"
        (deleteAtIndex)="unions.splice($event, 1)"></app-union>
    </div>
  </div>
  <div class="p-30" style="padding-top: 0px !important">
    <p *ngIf="unions.length < 25" class="pointer light-blue no-margin"
      (click)="unions.push({unionName: '', man: true, firstName: '', lastName: '', role: ''})">
      + Ajouter une organisation syndicale
    </p>
  </div>

</div>